import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import Axios from "axios";
import { Form, Input, Button, message } from "antd";

import { useAppDispatch } from "../../../hooks/reduxHooks";
import { storeUserData } from "../../../store/slice/profile.slice";
import handleNavigation from "../../../utils/paymentNavigation";

interface NotificationComponentInterface {
  onFinish: any;
}

const LoginFormComponent: React.FC<NotificationComponentInterface> = (
  props
) => {
  const { onFinish } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [submitting, setSubmitting] = useState(false);
  const location = useLocation();

  const authSuccess = () => {
    messageApi.open({
      type: "success",
      content: "You've Sucessfully Loged In!",
    });
  };

  const authError = () => {
    messageApi.open({
      type: "error",
      content: "Username or Password don't match with each other.",
    });
  };

  const handleLoginSubmission = async (val: any) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_API_DOMAIN}api/${process.env.REACT_APP_API_VERSION}/login`;
    const response = await Axios.post(
      url,
      {
        email: val.username,
        password: val.password,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    ).then(
      (response?: any) => {
        setSubmitting(false);
        if (response?.data?.success) {
          message.success("You've Sucessfully Loged In!");
          localStorage.setItem("alrounderToken", response.data.data.token);
          dispatch(storeUserData(response?.data?.data?.user));
          if (location?.hash === "#unsubscribe") {
            navigate("/edit-profile#unsubscribe");
            return;
          }
          navigate(
            handleNavigation(
              response?.data?.data?.user?.survey_status,
              response?.data?.data?.user?.has_store
            )
          );
          navigate("/");
        } else {
          message.error(response?.data?.message);
        }
      },
      (error) => {
        setSubmitting(false);
        message.error(
          error?.response?.data?.message ??
            "Email or Password didn't match with each other."
        );
      }
    );
  };

  return (
    <div className="auth-form auth-form--login">
      <Form
        name="login"
        layout="vertical"
        onFinish={(val) => {
          handleLoginSubmission(val);
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Email"
          name="username"
          rules={[{ required: true, message: "Please input your email!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password />
        </Form.Item>

        <Button
          htmlType="submit"
          block
          className="btn-primary"
          loading={submitting}
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default LoginFormComponent;
